import React, { useEffect, useRef, useState } from "react";
import close from "../../assets/images/close.svg";
import clear from "../../assets/images/clear.svg";
import {
  NotificationGetList,
  UpdateNotification,
  ReadAllNotification,
  NotificationGetListHeader,
} from "../../services/ReduxTookit/Slice/NotificationRedux";
import { useDispatch, useSelector } from "react-redux";
import { commonservices } from "../../services/CommonServices";
import Loader, { LoaderType } from "./Loader";
import Nodata from "./Nodata";
import { useNavigate } from "react-router-dom";

function NotificationPopup({
  closePopup,
  associationId,
  associationType,
  setgetNotificationList,
}) {
  let Userdata = useSelector((state) => state?.userinfo?.UserInfo);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [moreLoading, setMoreLoading] = useState(false);
  const moreLoadingRef = useRef(false);
  const [notificationList, setNotificationList] = useState([]);
  
  const navigate = useNavigate();
  const notificationListRef = useRef([]);
  const [totalRecord, setTotalRecord] = useState(1);
  const [page, setPage] = useState(1);
  const elementsRef = useRef([]);
  const apiCalledIdRef = useRef(new Set());

  const updateNotificationFn = async (id) => {
    if (apiCalledIdRef.current.has(id)) return; // Prevent duplicate calls

    apiCalledIdRef.current.add(id); // Mark as called

    let body = {
      notificationid: id,
      readby: `${Userdata?.userid}`,
    };

    dispatch(UpdateNotification(body)).then((res) => {
      if (res?.payload?.isValidate) {
        setNotificationList((prevList) =>
          prevList.map((item) =>
            item?.notificationid === id
              ? {
                  ...item,
                  readby: item?.readby
                    ? `${item.readby},${Userdata?.userid}`
                    : `${Userdata?.userid}`,
                }
              : item
          )
        );
      }
    });
  };

  const handleIntersection = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const id = entry.target.getAttribute("data-id");
        const readBy = entry.target.getAttribute("data-read") || "";
        const isRead = entry.target.getAttribute("data-isread") === "true";
        const isNotificationRead =
          isRead || readBy.includes(`${Userdata?.userid}`);

        if (!isNotificationRead && !apiCalledIdRef.current.has(id)) {
          if ("requestIdleCallback" in window) {
            requestIdleCallback(() => updateNotificationFn(id), {
              timeout: 2000,
            });
          } else {
            setTimeout(() => updateNotificationFn(id), 2000);
          }
        }
      }
    });
  };

  // const handleIntersection = (entries) => {
  //   entries.forEach((entry) => {
  //     const id = entry.target.getAttribute("data-id");
  //     const readBy = entry.target.getAttribute("data-read");
  //     const isRead = entry.target.getAttribute("data-isread");
  //     if (entry.isIntersecting) {
  //       let isNotificationRead = readBy?.includes(`${Userdata?.userid}`);
  //       let isApiCalled = apiCalledIdRef.current?.filter((x) => x === id);
  //       if (!isNotificationRead && isApiCalled?.length <= 0) {
  //         setTimeout(() => {
  //           apiCalledIdRef.current = [...apiCalledIdRef.current, id];
  //           updateNotificationFn(id);
  //         }, 2000);
  //       }
  //     } else {
  //     }
  //   });
  // };
  let DevRoute = window.location.href.includes(`${process.env.REACT_APP_DEV}`);
  

  useEffect(() => {
    const observer = new IntersectionObserver(handleIntersection, {
      root: null,
      rootMargin: "0px",
      threshold: 1.0,
    });

    elementsRef.current.forEach((el) => {
      if (el) observer.observe(el);
    });

    return () => {
      elementsRef.current.forEach((el) => {
        if (el) observer.unobserve(el);
      });
    };
  }, [notificationList]);

  const getNotificationList = async () => {
    if (page !== 1) {
      setMoreLoading(true);
    }
    let body = {
      type: "",
      entrydate: "",
      notificationto: "",
      readby: `${Userdata?.userid}`,
      pagenumber: page,
      pagesize: 10,
      associationid: associationId,
      associationtype: associationType,
    };
    dispatch(NotificationGetList(body))
      .then((res) => {
        if (res?.payload?.isValidate) {
          setNotificationList((prev) => [...prev, ...res?.payload?.data?.data]);
          notificationListRef.current = [
            ...notificationListRef.current,
            ...res?.payload?.data?.data,
          ];
          setTotalRecord(res?.payload?.data?.recordcount);
        } else {
          if (page === 1) {
            setNotificationList(null);
          }
          setTotalRecord(1);
        }
      })
      .finally(() => {
        moreLoadingRef.current = false;
        setLoading(false);
        setMoreLoading(false);
      });
  };

  useEffect(() => {
    getNotificationList();
  }, [page]);

  const readAllNotification = () => {
    dispatch(ReadAllNotification()).then((res) => {
      if (res?.payload?.isValidate) {
      apiCalledIdRef.current = new Set();
      notificationListRef.current = [];
      setNotificationList([]);
        setPage(1);
        setTimeout(() => {
        getNotificationList();
      },200);

        let body = {
          type: "",
          entrydate: "",
          notificationto: "",
          readby: `${Userdata?.userid}`,
          pagenumber: 1,
          pagesize: 10,
          associationid: "",
          associationtype: "",
        };
        dispatch(NotificationGetListHeader(body));
      } else {
      }
    });
  };

  const debounce = (func, delay) => {
    let timeoutId;
    return function (...args) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  const handleScroll = () => {
    let data = document.getElementById("notification-body");
    if (data) {
      const { scrollTop, scrollHeight, clientHeight } = data;
      if (
        scrollTop + clientHeight >= scrollHeight - 5 &&
        !moreLoadingRef.current &&
        notificationList?.length < totalRecord
      ) {
        moreLoadingRef.current = true;
        setPage((prev) => prev + 1);
      }
    }
  };

  useEffect(() => {
    const popupBody = document.getElementById("notification-body");
    const debouncedScroll = debounce(handleScroll, 200);
    if (popupBody) {
      popupBody.addEventListener("scroll", debouncedScroll);
    }

    return () => {
      if (popupBody) {
        popupBody.removeEventListener("scroll", debouncedScroll);
      }
    };
  },[]);
  const ManageNotificationRedirect = (data) => {
    if (data?.associationtype?.split(",")?.includes("workflow") && !DevRoute) {
      let a = commonservices.bodyEncryption(data?.associationid, true);
      // navigate(`/flow-new/${a}`, {
      navigate(`/flow-new-view/${a}`, {
        state: {
          isViewMode: true,
        },
      });
      closePopup();
    }

    if (data?.associationtype?.split(",")?.includes("machine")) {
      navigate(
        `/marketplace/marketplace-detail/${commonservices.bodyEncryption(
          String(data?.associationid)
        )}/Marketplace`
      );
      closePopup();
    }
  };

  return (
    <div className="schedular-popup notification-popup">
      <div className="popup-title">
        <h2>Notifications</h2>
        <div className="d-flex align-items-center gap-3">
          <div
            className="clear-all"
            onClick={(e) => {
              readAllNotification();
            }}
          >
            <img style={{ width: "18px" }} src={clear} alt="clear" />
            <span className="theme-color-text fw600">Read All</span>
          </div>
          <img
            src={close}
            alt="close"
            id="notification-main"
            className="cursor-pointer"
            onClick={closePopup}
          />
        </div>
      </div>
      <div className="popup-body" id="notification-body">
        <>
          {loading ? (
            <div className="no-data-fount-notification">
              <Loader type={LoaderType.NotificationList} count={10} />
            </div>
          ) : notificationList?.length > 0 ? (
            <div className="all-notification-main">
              {notificationList?.map((item, index) => {
                let isNotiRead = item?.readby?.includes(`${Userdata?.userid}`);
                return (
                  <div
                    ref={(el) => (elementsRef.current[index] = el)}
                    data-id={item?.notificationid}
                    data-read={item?.readby ? item?.readby : ""}
                    data-isread={item?.isread ? item?.isread : ""}
                    key={item?.notificationid}
                    onClick={() => ManageNotificationRedirect(item)}
                    className={`single-notification ${
                      isNotiRead || item?.isread ? "read-notification" : ""
                    }`}
                  >
                    <div className="single-notification-left">
                      <h6>{item?.title}</h6>
                      <div dangerouslySetInnerHTML={{ __html: item?.detail }} />
                      {/* <p>{item?.detail}</p> */}
                    </div>
                    <div className="single-notification-right">
                      <p>
                        {item?.entrydate
                          ? commonservices.convertDateAndTimeInLocalTimeZone(
                              item?.entrydate,
                              "MM/DD/YYYY"
                            )
                          : ""}
                      </p>
                      <span>
                        {item?.entrydate
                          ? commonservices.convertDateAndTimeInLocalTimeZone(
                              item?.entrydate,
                              "HH:mm"
                            )
                          : ""}
                      </span>
                    </div>
                    <div className={`unread-notification`}></div>
                  </div>
                );
              })}
              {moreLoading && (
                <>
                  <Loader type={LoaderType.NotificationList} count={5} />
                </>
              )}
            </div>
          ) : (
            <div className="no-data-found">
              <Nodata />
            </div>
          )}
        </>
      </div>
    </div>
  );
}

export default NotificationPopup;
